interface ResizeHandleProps {
  onResizeStart: (e: React.MouseEvent) => void;
  show: boolean;
}

export function ResizeHandle({ onResizeStart, show }: ResizeHandleProps) {
  if (!show) return null;

  return (
    <div
      className="absolute left-0 top-0 w-1 h-full hover:w-2 hover:bg-pink-500 hover:bg-opacity-50 cursor-col-resize transition-all duration-150 z-10 hidden md:block"
      onMouseDown={onResizeStart}
      style={{ left: '-2px' }}
    />
  );
}
